/**
 * 积分相关 API
 */

import { get } from './request';
import type { CreditsLogResult } from '@shared/types';

/** 查询积分流水 */
export function getCreditsLogs(params: {
  page?: number
  perPage?: number
  type?: -1 | 1
  date?: string
}): Promise<CreditsLogResult> {
  return get<CreditsLogResult>('/credits/logs', params as Record<string, unknown>);
}
